module.exports = __webpack_public_path__ + "static/media/nx.af8ff67a.png";